import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCopy } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, InputGroup } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import { TwoFactorAuthSetupModel } from "services/api/cplauthapi/CPLAuthAPI";

type Props = {
  setupData: TwoFactorAuthSetupModel;
};

export default function TwoFactorAppDisplay(props: Props) {
  const { setupData } = props;
  return (
    <>
      <div className="qr-code-section">
        <div className="qr-code-label">Scan QR code:</div>
        <div className="qr-code-container">
          <img src={setupData?.qrCodeImageURL} alt="QR code to scan" />
        </div>
      </div>
      <div className="manual-code-section">
        <div>Or enter this code manually: </div>
        <InputGroup className="manual-code-copy-group">
          <Form.Control
            className="manual-code-text"
            disabled
            readOnly
            value={setupData.manualSetupCode}
            data-test-id="two-factor-app-setup__manual-code-input"
          />
          <CopyToClipboard text={setupData.manualSetupCode ?? ""} onCopy={() => alert("Text copied")}>
            <Button
              className="btn btn-secondary"
              onClick={(e) => e.currentTarget.blur()}
              data-test-id="two-factor-app-setup__copy-code-button"
            >
              <FontAwesomeIcon icon={faCopy as IconProp} />
            </Button>
          </CopyToClipboard>
        </InputGroup>
      </div>
    </>
  );
}
